var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenWithLineRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#ffbe00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6607 19.0561C19.9857 19.0561 20.25 19.3238 20.25 19.653C20.25 19.9829 19.9857 20.25 19.6607 20.25H16.3298C16.0048 20.25 15.7405 19.9829 15.7405 19.653C15.7405 19.3238 16.0048 19.0561 16.3298 19.0561H19.6607ZM17.3507 10.1578L18.2112 10.8413C18.564 11.1172 18.7992 11.4809 18.8797 11.8634C18.9726 12.2842 18.8735 12.6974 18.595 13.0548L13.4696 19.6829C13.2343 19.9839 12.8877 20.1532 12.5163 20.1595L10.4736 20.1846C10.3621 20.1846 10.2693 20.1093 10.2445 20.0027L9.78027 17.9899C9.6998 17.6199 9.78027 17.2374 10.0155 16.9427L13.6491 12.2397C13.711 12.1644 13.8224 12.1525 13.8967 12.2083L15.4256 13.4248C15.5247 13.5063 15.6609 13.5502 15.8032 13.5314C16.1065 13.4938 16.3108 13.2179 16.2799 12.9232C16.2613 12.7727 16.187 12.6472 16.088 12.5532C16.057 12.5281 14.6024 11.3618 14.6024 11.3618C14.5095 11.2865 14.4909 11.1486 14.5652 11.0551L15.1409 10.3083C15.6732 9.62478 16.6017 9.56207 17.3507 10.1578Z",
    fill: "#212B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenWithLineRound);
export default __webpack_public_path__ + "static/media/pen-with-line-round.9b843735c953bfe480a9b393a033f728.svg";
export { ForwardRef as ReactComponent };